import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useApiPost } from '../../../../api/hooks';
import Modal from '../controls/Modal';
import LabeledInput from '../controls/LabeledInput';
import PasswordRules, { isValidPassword } from '../controls/PasswordRules';

const USERS_URL = '/api/camps/admin/users';
const MIN_USERNAME = 3;

const EMPTY_FORM = { name: '', surname: '', username: '', password: '' };

// Модалка создания организатора. Валидация: логин ≥3, пароль ≥8 с цифрой, имя/фамилия.
export default function CreateOrgModal({ open, onClose, onCreated }) {
    const [form, setForm] = useState(EMPTY_FORM);

    const createOrg = useApiPost({
        successMessage: 'Организатор создан',
        withPreloader: true,
        onSuccess: (data) => {
            onCreated({ ...data, name: form.name, surname: form.surname });
            setForm(EMPTY_FORM);
            onClose();
        }
    });

    const setField = (field) => (e) => setForm({ ...form, [field]: e.target.value });

    const isValid =
        form.username.trim().length >= MIN_USERNAME &&
        isValidPassword(form.password) &&
        form.name.trim() &&
        form.surname.trim();

    const handleSubmit = () => {
        createOrg.mutate({
            url: USERS_URL,
            data: {
                username: form.username,
                password: form.password,
                profile: { name: form.name, surname: form.surname }
            }
        });
    };

    const footer = (
        <>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={!isValid || createOrg.isPending}
            >
                Создать
            </button>
        </>
    );

    return (
        <Modal open={open} title="Создать организатора" onClose={onClose} size="sm" footer={footer}>
            <LabeledInput label="Имя" value={form.name} onChange={setField('name')} />
            <LabeledInput label="Фамилия" value={form.surname} onChange={setField('surname')} />
            <LabeledInput label="Логин (мин. 3 символа)" value={form.username} onChange={setField('username')} />
            <div>
                <LabeledInput
                    label="Пароль"
                    type="password"
                    value={form.password}
                    onChange={setField('password')}
                />
                <PasswordRules password={form.password} />
            </div>
        </Modal>
    );
}

CreateOrgModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCreated: PropTypes.func.isRequired
};
